import React, { useState } from "react";
import { IRestaurantTable } from "../models/IReservation";
import { postRestaurantTable, putRestaurantTable } from "../services/reservationService";

interface Props {
  restaurantId: string;
  table?: IRestaurantTable;
  onClose: () => void;
  onSaved: () => void;
}

const inputStyle: React.CSSProperties = { borderRadius: 10, border: "1.5px solid #e5e7eb" };

export default function TableFormModal({ restaurantId, table, onClose, onSaved }: Props) {
  const isEdit = !!table;
  const [tableNumber, setTableNumber] = useState(table ? String(table.tableNumber) : "");
  const [capacity, setCapacity] = useState(table ? String(table.capacity) : "");
  const [minCapacity, setMinCapacity] = useState(table ? String(table.minCapacity) : "");
  const [label, setLabel] = useState(table?.label ?? "");
  const [isEnabled, setIsEnabled] = useState(table?.isEnabled ?? true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!tableNumber || !capacity || !minCapacity || !label.trim()) {
      setError("Lütfen tüm alanları doldurun.");
      return;
    }
    setSaving(true);
    setError("");

    const request = isEdit
      ? putRestaurantTable({
          id: table!.id,
          tableNumber: Number(tableNumber),
          capacity: Number(capacity),
          minCapacity: Number(minCapacity),
          label: label.trim(),
          isEnabled,
        })
      : postRestaurantTable({
          restourantId: restaurantId,
          tableNumber: Number(tableNumber),
          capacity: Number(capacity),
          minCapacity: Number(minCapacity),
          label: label.trim(),
        });

    request
      .then(() => {
        onSaved();
        onClose();
      })
      .catch(() => setError(isEdit ? "Masa güncellenemedi." : "Masa oluşturulamadı."))
      .finally(() => setSaving(false));
  };

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(3px)" }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ background: "#fff", borderRadius: 20, padding: "28px 28px 22px", width: "min(96vw, 400px)", boxShadow: "0 8px 40px rgba(0,0,0,0.18)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 22 }}>
          <div style={{ fontWeight: 800, fontSize: "1rem", color: "#111827", display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 34, height: 34, borderRadius: 10, background: "#f0fdfa", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <i className="bi bi-grid-3x3-gap-fill" style={{ color: "#0d9488", fontSize: "1rem" }}></i>
            </div>
            {isEdit ? "Masayı Düzenle" : "Masa Ekle"}
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: "1.2rem" }}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={{ fontSize: "0.78rem", fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Masa Numarası</label>
            <input
              type="number"
              value={tableNumber}
              onChange={(e) => setTableNumber(e.target.value)}
              className="form-control"
              style={inputStyle}
              placeholder="Örn. 2"
            />
          </div>
          <div>
            <label style={{ fontSize: "0.78rem", fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Etiket</label>
            <input
              type="text"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              className="form-control"
              style={inputStyle}
              placeholder="Örn. Deniz Kenarı"
            />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <div>
              <label style={{ fontSize: "0.78rem", fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Min. Kapasite</label>
              <input
                type="number"
                value={minCapacity}
                onChange={(e) => setMinCapacity(e.target.value)}
                className="form-control"
                style={inputStyle}
                placeholder="Örn. 4"
              />
            </div>
            <div>
              <label style={{ fontSize: "0.78rem", fontWeight: 600, color: "#374151", display: "block", marginBottom: 6 }}>Kapasite</label>
              <input
                type="number"
                value={capacity}
                onChange={(e) => setCapacity(e.target.value)}
                className="form-control"
                style={inputStyle}
                placeholder="Örn. 6"
              />
            </div>
          </div>

          {isEdit && (
            <div
              onClick={() => setIsEnabled((v) => !v)}
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", borderRadius: 12, border: "1.5px solid #e5e7eb", cursor: "pointer", userSelect: "none" }}
            >
              <span style={{ fontSize: "0.85rem", fontWeight: 600, color: "#374151" }}>
                <i className={`bi ${isEnabled ? "bi-toggle2-on text-success" : "bi-toggle2-off text-secondary"} me-2`} style={{ fontSize: "1.1rem" }}></i>
                Masa Aktif
              </span>
              <span style={{ fontSize: "0.78rem", fontWeight: 700, color: isEnabled ? "#059669" : "#6b7280" }}>
                {isEnabled ? "Açık" : "Kapalı"}
              </span>
            </div>
          )}

          {error && (
            <div style={{ background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 10, padding: "8px 12px", color: "#b91c1c", fontSize: "0.82rem" }}>
              <i className="bi bi-exclamation-circle me-1"></i>{error}
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 22, justifyContent: "flex-end" }}>
          <button onClick={onClose}
            style={{ padding: "9px 18px", borderRadius: 10, border: "1.5px solid #e5e7eb", background: "#fff", color: "#6b7280", fontWeight: 600, fontSize: "0.85rem", cursor: "pointer" }}>
            İptal
          </button>
          <button onClick={handleSave} disabled={saving}
            style={{
              padding: "9px 22px", borderRadius: 10, border: "none",
              background: "linear-gradient(135deg, #0d9488, #0f766e)",
              color: "#fff", fontWeight: 700, fontSize: "0.85rem",
              cursor: saving ? "not-allowed" : "pointer",
              display: "flex", alignItems: "center", gap: 7,
              opacity: saving ? 0.7 : 1,
            }}
          >
            {saving
              ? <><span className="spinner-border spinner-border-sm"></span> Kaydediliyor...</>
              : <><i className="bi bi-check-lg"></i> Kaydet</>
            }
          </button>
        </div>
      </div>
    </div>
  );
}
